import { axios } from 'common/utils'
import { ProductCategoryParams } from 'common/types/params/productCategory'
import { ProductCategory } from 'common/types/entities/mongo/productCategory'

export const fetchProductCategories = async (params: ProductCategoryParams): Promise<ProductCategory[]> => {
  const result = await axios.get<ProductCategory[]>(`/v1/product-categories`, {
    params,
  })
  return result && result.data
}

export const fetchProductCategory = async (id: string): Promise<ProductCategory> => {
  const result = await axios.get<ProductCategory>(`/v1/product-categories/${id}`, {})
  return result && result.data
}
